import { useCallback, useEffect } from "react";
import { useMe } from "@/data/user";
import { debounce } from "lodash";
import { useLocation } from "react-router-dom";

const Intercom = () => {
  const { me } = useMe();
  const location = useLocation();
  const path = location.pathname;

  // Debounced resize handler
  const debouncedResizeHandler = useCallback(
    debounce(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const IC = window.Intercom;
      if (typeof IC === "function") {
        if (path.indexOf("dashboard") === -1) {
          IC("update", {
            hide_default_launcher: false,
            alignment: "left",
          });
        } else if (window.innerWidth < 764) {
          IC("update", {
            hide_default_launcher: true,
            alignment: "right",
          });
        } else {
          IC("update", {
            hide_default_launcher: false,
            alignment: "left",
          });
        }
      }
    }, 300), // Debounce with 300ms delay
    [path],
  );

  const loadInterCom = useCallback(() => {
    const w = window;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const ic = w.Intercom;
    if (typeof ic === "function") {
      ic("reattach_activator");
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      ic("update", w.intercomSettings);
    } else {
      const d = document;
      const i = function (...args: never[]) {
        i.c(args);
      };
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      i.q = [];
      i.c = function (args: never[]) {
        i.q.push(args);
      };
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      w.Intercom = i;
      const l = function () {
        const s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://widget.intercom.io/widget/kox3e4lb";
        const x = d.getElementsByTagName("script")[0];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        x.parentNode.insertBefore(s, x);
        // s.onload = onResize;
        // call onResize function after script has loaded completely
        s.onload = () => {
          debouncedResizeHandler();
        };
      };
      if (document.readyState === "complete") {
        l();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
      } else if (w.attachEvent) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        w.attachEvent("onload", l);
      } else {
        w.addEventListener("load", l, false);
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      window.Intercom("boot", {
        app_id: "kox3e4lb",
      });
    }
  }, [debouncedResizeHandler]);

  useEffect(() => {
    loadInterCom();
    window.addEventListener("resize", debouncedResizeHandler);

    return () => {
      window.removeEventListener("resize", debouncedResizeHandler);
    };
  }, [loadInterCom, debouncedResizeHandler]);

  useEffect(() => {
    if (me) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: "kox3e4lb",
        name: `${me.item.user.first_name + " " + me.item.user.last_name}`,
        email: me.item.user.email,
        phone: me.item.user.phone,
        user_token: me.item.user.token,
        user_id: me.item.user.token,
        start_month: me.item.user.start_month,
        user_hash: me.item.user.user_hash,
      };

      loadInterCom();
      // onResize();
      debouncedResizeHandler();
    }
  }, [me, loadInterCom, debouncedResizeHandler]);

  return <></>;
};

export default Intercom;
